import { render, staticRenderFns } from "./image-input.vue?vue&type=template&id=4611a603&scoped=true&"
import script from "./image-input.vue?vue&type=script&lang=ts&"
export * from "./image-input.vue?vue&type=script&lang=ts&"
import style0 from "./image-input.vue?vue&type=style&index=0&id=4611a603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4611a603",
  null
  
)

export default component.exports